import {MOBILE_M_BREAKPOINT} from '@constant/system';

const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    assetsRowContainer: {
      width: '100%',
      padding: '0px 10px',
    },
    borderContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    row: {
      width: '100%',
      margin: 'auto',
      display: 'flex',
      padding: '10px 0',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 10,
      '&.emptySpace': {
        padding: '5px 0',
      },
    },

    moneyRowGameDemo: {
      extend: 'moneyRow',
      justifyContent: 'flex-end',
    },
    leftColumn: {
      height: 'fit-content',
      width: 'inherit',
    },

    rightColumn: {
      height: 'fit-content',
      width: 'inherit',
    },
    rightColumnGameDemo: {
      extend: 'rightColumn',
      width: ' calc(50% - 4px)',
    },
    coinBarContainer: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      // marginBottom: '5px',
      width: '100%',
      justifyContent: 'flex-end',
    },
    numberContainer: {
      width: '100%',
      height: 30,
      // margin: '10px 0',
      // backgroundSize: '100% 100%',
      borderRadius: 10,
      background: 'rgba(255, 255, 255, 0.10)',
      padding: 5,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      '& .ant-statistic': {
        '& .ant-statistic-content': {
          fontFamily: 'PingFang HK',
        },
        '& .ant-statistic-content-prefix': {
          marginRight: '0px',
        },
      },
    },
    numberContainerLeft: {
      extend: 'numberContainer',
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      cursor: 'pointer',
      transition: 'background 0.3s, transform 0.1s',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.2)',
      },
      '&:active': {
        transform: 'scale(0.95)',
        background: 'rgba(255, 255, 255, 0.2)',
      },

      '&.unclickable': {
        cursor: 'default',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.10)',
        },
        '&:active': {
          transform: 'scale(1)',
          background: 'rgba(255, 255, 255, 0.10)',
        },
      },
    },
    addIcon: {
      position: 'absolute',
      alignSelf: 'flex-end',
      right: 2.5,
    },
    usdStatistic: {
      transform: 'translateX(-5px)',
    },
    numberContainerRight: {
      extend: 'numberContainer',
      position: 'relative',
      justifyContent: 'space-between',
      cursor: 'pointer',
      transition: 'background 0.3s, transform 0.1s',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.2)',
      },
      '&:active': {
        transform: 'scale(0.95)',
        background: 'rgba(255, 255, 255, 0.2)',
      },
    },
    coinBarIcon: {
      fontSize: 25,
      bottom: '7px !important',
      height: '25px',
      width: '25px',
      zIndex: '99',
      marginRight: '5px',
    },
    usdIcon: {
      extend: 'coinBarIcon',
      transform: 'translateX(-6px)',
    },
    diamondIcon: {
      extend: 'coinBarIcon',
      marginLeft: '5px',
    },
    onlinePlayerCountContainer: {
      height: 30,
      borderRadius: 10,
      color: 'white',
      gap: 5,
      background: 'rgba(255, 255, 255, 0.10)',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 5px',
    },
    hidden: {display: 'none'},

    [`@media only screen and (max-width: ${MOBILE_M_BREAKPOINT}px)`]: {
      // TODO: remove repeat code if possible
      numberContainerLeft: {
        '& .ant-statistic': {
          '& .ant-statistic-content': {
            fontSize: 'min(3.5vw,12px) !important',
          },
        },
      },
      numberContainerRight: {
        '& .ant-statistic': {
          '& .ant-statistic-content': {
            fontSize: 'min(3.5vw,12px) !important',
          },
        },
      },
      usdIcon: {
        marginRight: '0px !important',
      },
      coinBarIcon: {
        marginRight: '0px',
      },
      diamondIcon: {
        marginRight: '0px',
        marginLeft: '0px',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
